import React from "react"

interface Props {
  label: string
  required: boolean
  htmlFor: string
  error?: string
}

const FormLabel = (props: Props) => (
  <div className="grid grid-flow-col">
    <label className="text-gray-600 font-bold gc-uppercase" htmlFor={props.htmlFor}>
      {props.label}
      {props.required && <span> *</span>}
    </label>
    <div className="text-right">
      {props.error && <div className="text-red-700 font-bold">{props.error}</div>}
    </div>
  </div>
)

export default FormLabel
